import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ManageUsers from "./ManageUsers";
import { GetUsers } from "../centralAdminSlice";

export default function UserAdministration() {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const { getUserDataInitially } = centralAdmin;

  useEffect(() => {
    if (getUserDataInitially.length <= 0) {
      dispatch(GetUsers({ method: "Get" }));
    }
  }, []);

  console.log("getUserDataInitially", getUserDataInitially);

  return (
    <Box>
      <ManageUsers />
    </Box>
  );
}
